var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M195.806,116.161h35.956v120.653H60.435c-19.993,0-36.196-13.503-36.196-30.163c0-16.659,16.203-30.162,36.196-30.162 c12.032-0.001,22.697,4.892,29.275,12.421V99.626c-6.578-7.529-17.243-12.423-29.275-12.421 c-19.993,0-36.196,13.505-36.196,30.163v87.153"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.858,
    y1: 116.161,
    x2: 136.959,
    y2: 116.161
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M212.635,66.033c0,25.873-46.85,104.771-46.85,104.771s-46.85-78.898-46.85-104.771c0-25.873,20.975-46.846,46.85-46.846 C191.66,19.186,212.635,40.16,212.635,66.033z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M185.792,66.033c0,11.048-8.954,20.016-20.007,20.016c-11.05,0-20.003-8.968-20.003-20.016c0-11.048,8.953-20.007,20.003-20.007 C176.838,46.026,185.792,54.985,185.792,66.033z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3d98db4c5f2e1c8bace4ce63a3d0dc46.svg";
export { ForwardRef as ReactComponent };